import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Output } from '@angular/core';
import { InsuranceFlowDetailsResponse } from 'src/app/_types/insurance-flow.types';
import {
  CreateLeadResponse,
  ProposalDetails,
} from 'src/app/_types/proposals.type';
import { AddLeadModalComponent } from 'src/app/shared/components/add-lead-modal/add-lead-modal.component';
import { InitCommissionButtonComponent } from 'src/app/shared/components/init-commission-button/init-commission-button.component';
import { CopyFlowLinksComponent } from '../copy-flow-links/copy-flow-links.component';
import { TaskDetailsService } from '../../task-details.service';

/**
 * Action block of the task details header.
 * Shared by the slide-in modal and the standalone page, which handle `leadCreated` differently.
 */
@Component({
  selector: 'app-task-details-header-actions',
  standalone: true,
  imports: [
    CommonModule,
    AddLeadModalComponent,
    InitCommissionButtonComponent,
    CopyFlowLinksComponent,
  ],
  templateUrl: './task-details-header-actions.component.html',
  styleUrl: './task-details-header-actions.component.css',
})
export class TaskDetailsHeaderActionsComponent {
  @Output() leadCreated = new EventEmitter<CreateLeadResponse>();

  constructor(private readonly taskDetailsService: TaskDetailsService) {}

  protected get isLoading(): boolean {
    return this.taskDetailsService.state.isLoading;
  }

  protected get insuranceFlowData(): InsuranceFlowDetailsResponse | null {
    return this.taskDetailsService.state.insuranceFlowData;
  }

  protected get policy(): ProposalDetails | null {
    return this.taskDetailsService.state.policy;
  }

  protected get flowId(): string | null {
    return this.taskDetailsService.state.insuranceFlowData?.id ?? null;
  }

  protected refresh(): void {
    this.taskDetailsService.refreshTaskDetails();
  }
}
